module.exports = __webpack_public_path__ + "img/face21.2abe31b8.gif";